import { FC } from 'react'

export const TextSubtext: FC<{
  text: string
  subtext?: string
  className?: string
  textClassName?: string
}> = ({ subtext, text, className, textClassName }) => {
  return (
    <div className={`flex flex-col gap-1 ${className}`}>
      <p className={`text-base font-medium text-black ${textClassName}`}>
        {text}
      </p>
      {subtext && (
        <p className="text-sm font-normal text-sec-black">{subtext}</p>
      )}
    </div>
  )
}
